<template>
    <div>
        喜欢
    </div>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/space/Like.vue